module.exports = __webpack_public_path__ + "static/media/logo.61ec00ec.jpg";